import React, { Component } from 'react';
//material
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button_container';
//utils
// import { createFormDataBlobWithFile } from 'utils/shared_form_utils';


class PaymentInfoCTAs extends Component {
    constructor(props){
        super(props);
        this.preferred = false;
    }


    // displayCTAs = () => {
    //     switch (this.props.location) {
    //         case 'selectmethod':
    //             return (
    //
    //             );
    //         case 'enterinformation':
    //             return ( this.props.previousPage === 'dashboard/account/paymentinfo/selectmethod' ?
    //                     <CTAs>
    //                         <Button type={'internal'} action={this.props.previousPage} variant={`system`} name={`back`} text={`Back`} />
    //                         <Button type={'action'} action={this.props.primaryAction} variant={`action`} name={`save`} text={`Save`} />
    //                     </CTAs>
    //                     :
    //                     <CTAs>
    //                         <Button type={'internal'} action={this.props.previousPage} variant={`system`} name={`back`} text={`Back`} />
    //                         {this.props.editable ? <Button type={'action'} action={this.handleSave} variant={`action`} name={`save`} text={`Save`} />
    //                             :
    //                             <Button type={'action'} action={()=>this.props.setFormEditableState(this.props.formName, !this.props.editable)} variant={`primary`} name={`edit`} text={`Edit this payment information`} />}
    //                     </CTAs>
    //             );
    //         case 'existingpayments':
    //             return (
    //                 <CTAs>
    //                     <Button type={'internal'} action={`dashboard/account/paymentinfo/selectmethod`} variant={`primary`} name={`addpayment`} text={`Add Payment Method`} />
    //                 </CTAs>
    //             );
    //         default: break;
    //     }
    // };


    render(){
        return (
            <CTAs>
                {this.props.secondaryAction && <Button type={'action'} action={this.props.secondaryAction} variant={`system`} name={`secondary`} text={this.props.secondaryButtonText} />}
                {this.props.primaryAction && <Button type={'action'} action={this.props.primaryAction} variant={this.props.primaryVariant ? this.props.primaryVariant : 'primary'} name={`primary`} text={this.props.primaryButtonText} />}
            </CTAs>
        )
    }

}

export default (PaymentInfoCTAs)